import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODAzODQzNzZ8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative isolate overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url("${HERO_IMG}")` }}
      />
      <div aria-hidden className="absolute inset-0 bg-forest-950/85" />
      <div aria-hidden className="absolute inset-0 grain" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 pt-40 sm:pt-48 pb-24 sm:pb-32">
        <div className="max-w-3xl">
          <p className="text-brass text-sm uppercase tracking-[0.28em] mb-8 animate-fade-up">
            R&D Tax Credit · Cost Segregation
          </p>
          <h1
            className="font-serif text-ivory text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight animate-fade-up"
            style={{ animationDelay: "60ms" }}
          >
            Recover the cash the
            <br />
            tax code already
            <span className="italic text-brass"> owes you.</span>
          </h1>
          <p
            className="mt-8 text-ivory/85 text-lg sm:text-xl leading-relaxed max-w-2xl animate-fade-up"
            style={{ animationDelay: "140ms" }}
          >
            IncentTax helps real estate investors, business owners, and private
            equity firms unlock significant federal and state tax savings — and
            partners with CPAs to deliver these strategies to their clients.
          </p>

          <div
            className="mt-12 flex flex-col sm:flex-row gap-4 animate-fade-up"
            style={{ animationDelay: "220ms" }}
          >
            <a
              href="#estimator"
              className="inline-flex items-center justify-center gap-2 bg-brass text-forest-900 hover:bg-brass-500 px-8 py-4 font-medium transition-colors"
              data-testid="hero-cta-estimator"
            >
              Estimate My Savings <ArrowRight size={18} />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 border border-ivory/40 text-ivory hover:bg-ivory hover:text-forest-950 px-8 py-4 font-medium transition-colors"
              data-testid="hero-cta-consult"
            >
              Talk to an Advisor
            </a>
          </div>

          <div
            className="mt-16 flex flex-wrap gap-x-10 gap-y-4 text-ivory/70 text-sm animate-fade-up"
            style={{ animationDelay: "320ms" }}
          >
            <div className="flex items-center gap-2">
              <ShieldCheck size={16} className="text-brass" />
              IRS-compliant engineering studies
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck size={16} className="text-brass" />
              Audit-ready documentation
            </div>
          </div>
        </div>
      </div>

      {/* stats strip */}
      <div className="relative border-t border-ivory/10 bg-forest-950/60">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-10 grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-6">
          {[
            { v: "1,800+", l: "Properties analyzed" },
            { v: "92%", l: "of studies qualify" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-sans text-3xl sm:text-4xl text-ivory tabular tracking-tight">
                {s.v}
              </div>
              <div className="text-ivory/60 text-xs uppercase tracking-[0.22em] mt-2">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
